<ds-item-detail-preview [item]="item"
                        [object]="object"
                        [badgeContext]="badgeContext"></ds-item-detail-preview>

<ds-workflowitem-actions [object]="dso"></ds-workflowitem-actions>

